export function latestFinancialObservations(metrics) {
  const latest = new Map();

  for (const metric of metrics || []) {
    if (metric.data_type !== "currency" && !metric.currency) continue;
    const key = [metric.platform, metric.account_id, metric.metric_key].join("\u0000");
    const current = latest.get(key);
    if (!current || String(metric.captured_at || "") > String(current.captured_at || "")) {
      latest.set(key, metric);
    }
  }

  return Array.from(latest.values()).sort((left, right) =>
    String(right.captured_at || "").localeCompare(String(left.captured_at || ""))
  );
}